<template>
  <div class="button-decoration" @click="$emit('click')">
    <button :class="[buttonColor]">
      <slot />
    </button>
    <div class="ornaments">
      <div v-for="item in ornament" :key="item" class="ornament" />
    </div>
  </div>
</template>
<script>
export default {
  props: ['buttonColor'],
  computed: {
    ornament(){
      const ornaments = new Array(10)
      return ornaments
    }
  },
}
</script>
<style lang="scss" scoped>
.button-decoration {
  height: 210px;
  background: url(#{$img-path}contents-box-gold/bg_btn_decoration.png) no-repeat center 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

button {
  width: 584px;
}
.button-golden {
  background: url(#{$img-path}contents-box-gold/btn_golden.png) no-repeat center 0;
  height: 198px;
}
.button-blue {
  background: url(#{$img-path}contents-box-gold/btn_blue.png) no-repeat center 0;
  height: 195px;
}

.ornaments {
  position: absolute;
  top: 0;
  left: 0;
}
.ornament {
  width: 40px;
  height: 40px;
  background: url(#{$img-path}common/glitter.png) no-repeat;
  position: absolute;
  opacity: 0;
  z-index: 100;
  @for $i from 1 through 10 {
    &:nth-child(#{$i}) {
      top: random(160) + px;
      left: random(580) + px;
      animation: top-effect .6s random(20) * 0.1 + s ease-out both infinite alternate;
    }
  }
}

@keyframes top-effect {
  0% {
    opacity: 0;
    transform: scale(.1);
  }
  100% {
      opacity: 1;
      transform: scale(1.2);
  }
}
</style>
